import { ENTSWindow } from '../service/ENTSWindow.js';

export interface FilterRepository {
  getActiveOptions(): StoredActiveOption[];

  storeActiveOptions(activeOptions: StoredActiveOption[]): void;
}

declare const window: ENTSWindow;

export class FilterRepositoryImpl implements FilterRepository {
  public getActiveOptions(): StoredActiveOption[] {
    const valuesAsString = new URL(window.location.href).searchParams.get('filter');
    if (valuesAsString) {
      return valuesAsString.split(',').map((optionId) => new StoredActiveOption(optionId.trim()));
    }
    return [];
  }

  public storeActiveOptions(activeOptions: StoredActiveOption[]): void {
    const valuesAsString = activeOptions.map((activeOption) => activeOption.id).join(',');
    const url = new URL(window.location.href);
    if (valuesAsString.length > 0) {
      url.searchParams.set('filter', valuesAsString);
    } else {
      url.searchParams.delete('filter');
    }
    window.history.pushState({}, '', url.toString());
  }
}

export class StoredActiveOption {
  public readonly id: string;

  constructor(id: string) {
    this.id = id;
  }
}
